export type Category = {
  slug: string;
  name: string;
  desc: string;
  icon: string;
  cover: string;
  coverAlt: string;
};

export const categories: Category[] = [
  {
    slug: 'live',
    name: '直播翻车现场',
    desc: '把直播过程中的失控瞬间完整保留下来。黑屏、摔麦、下播，看的是镜头还没反应过来时的真实反应。',
    icon: 'ri-live-line',
    cover:
      'https://readdy.ai/api/search-image?query=Empty%20television%20studio%20stage%20with%20a%20large%20live%20broadcast%20camera%20pointing%20at%20an%20empty%20host%20chair%2C%20warm%20amber%20spotlights%20beaming%20down%20and%20cool%20teal%20backdrop%20lighting%2C%20cinematic%20editorial%20photography%2C%20moody%20empty%20atmosphere%2C%20film%20grain%2C%20high%20contrast%2C%20no%20people&width=800&height=600&seq=cat-live-stage&orientation=landscape',
    coverAlt: '空荡的直播演播厅与对着空椅子的摄像机',
  },
  {
    slug: 'offstage',
    name: '台下偶遇实录',
    desc: '来自机场、便利店、街角的一手目击记录。没有打光也没有脚本，只有一个人以为没人注意时的样子。',
    icon: 'ri-walk-line',
    cover:
      'https://readdy.ai/api/search-image?query=Quiet%20early%20evening%20city%20sidewalk%20corner%20with%20a%20small%20glowing%20shop%20window%2C%20warm%20amber%20lamp%20light%20spilling%20onto%20the%20pavement%2C%20cool%20teal%20dusk%20sky%20and%20blurred%20passersby%20in%20the%20distance%2C%20cinematic%20editorial%20photography%2C%20calm%20daily%20atmosphere%2C%20film%20grain%2C%20no%20clear%20faces&width=800&height=600&seq=cat-offstage-street&orientation=landscape',
    coverAlt: '傍晚街角亮着灯的小店橱窗',
  },
  {
    slug: 'fanleak',
    name: '粉丝爆料',
    desc: '来自长期近距离接触者的一手自述。不提供私人信息，只还原镜头前后那份难以对齐的期待差。',
    icon: 'ri-chat-private-line',
    cover:
      'https://readdy.ai/api/search-image?query=Moody%20editorial%20still%20life%20of%20stacked%20paper%20notebooks%20and%20a%20glowing%20phone%20on%20a%20dark%20desk%2C%20warm%20amber%20desk%20lamp%20on%20the%20left%20and%20cool%20teal%20light%20on%20the%20right%2C%20scattered%20sticky%20notes%2C%20cinematic%20shallow%20depth%20of%20field%2C%20film%20grain%2C%20no%20readable%20text&width=800&height=600&seq=cat-fan-chat&orientation=landscape',
    coverAlt: '堆叠的笔记本与发亮的手机屏幕',
  },
  {
    slug: 'candid',
    name: '私下被拍',
    desc: '公共场所的常规记录。我们只保留与公开言行相关的部分，涉及隐私、住所与家人的内容一律不呈现。',
    icon: 'ri-camera-lens-line',
    cover:
      'https://readdy.ai/api/search-image?query=Rainy%20midnight%20city%20street%20with%20wet%20reflective%20asphalt%20mirroring%20warm%20amber%20lamps%20and%20cool%20teal%20neon%20signs%2C%20empty%20crosswalk%2C%20cinematic%20editorial%20photography%2C%20lonely%20moody%20atmosphere%2C%20film%20grain%2C%20no%20people%20no%20faces&width=800&height=600&seq=cat-candid-night&orientation=landscape',
    coverAlt: '雨夜反射着霓虹的空荡街道',
  },
];

export const getCategory = (slug: string): Category | undefined =>
  categories.find((item) => item.slug === slug);